const KEY = "velta_page_size";
export const PAGE_SHORT = 20;
export const PAGE_LONG = 50;

export function getPageSize() {
  try {
    return Number(localStorage.getItem(KEY)) === PAGE_LONG ? PAGE_LONG : PAGE_SHORT;
  } catch {
    return PAGE_SHORT;
  }
}

export function setPageSize(n) {
  const v = Number(n) === PAGE_LONG ? PAGE_LONG : PAGE_SHORT;
  try { localStorage.setItem(KEY, String(v)); } catch { /* ignore */ }
  return v;
}

export function pageSlice(arr, page, size) {
  const list = Array.isArray(arr) ? arr : [];
  const pages = Math.max(1, Math.ceil(list.length / Math.max(1, size)) || 1);
  const p = Math.min(Math.max(1, page), pages);
  return {
    items: list.slice((p - 1) * size, p * size),
    total: list.length,
    page: p,
    pages,
  };
}
